module.exports = __webpack_public_path__ + "img/calendar.c0650c97.svg";